import { useDispatch } from "react-redux"

import { bindActionCreators } from "@reduxjs/toolkit"

import { actions } from "./projectSlice"

export function useProjectStoreActions() {
  const dispatch = useDispatch()
  return bindActionCreators(actions, dispatch)
}
